import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { OVERPAYMENT_REASON_API } from './consts'
import { OverpaymentReason } from './response.types'
import {
  CreateOverpaymentReasonRequest,
  ReorderRequest,
  UpdateOverpaymentReasonRequest,
} from './requests.types'

interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
  errors?: Record<string, string>
}

export const getReasons = (params: { enabled?: boolean; page?: number; perPage?: number }) =>
  axios.get<ApiResponse<OverpaymentReason[]>>(`${API_URL}${OVERPAYMENT_REASON_API}/list`, {
    params,
  })

export const createReason = (body: CreateOverpaymentReasonRequest) =>
  axios.post<ApiResponse<OverpaymentReason>>(`${API_URL}${OVERPAYMENT_REASON_API}`, body)

export const patchReason = (id: number, body: UpdateOverpaymentReasonRequest) =>
  axios.patch<ApiResponse<OverpaymentReason>>(`${API_URL}${OVERPAYMENT_REASON_API}/${id}`, body)

export const reorderReasons = (ids: number[]) =>
  axios.patch<ApiResponse<OverpaymentReason[]>>(`${API_URL}${OVERPAYMENT_REASON_API}/reorder`, {
    ids,
  } as ReorderRequest)
